import { Injectable } from '@angular/core';
import { User, Address, Invoice, Issue, Machines, Servicing, Storage, Transaction, Company } from './schema.interface';
import { Typesaurus, schema, groups } from 'typesaurus';
import { Id } from '@res/ngg-core';

export const db = schema(($) => ({
  users: $.collection<User>().sub({ addresses: $.collection<Address>() }),
  invoices: $.collection<Invoice>(),
  issues: $.collection<Issue>(),
  machines: $.collection<Machines>(),
  servicing: $.collection<Servicing>(),
  storage: $.collection<Storage>(),
  transactions: $.collection<Transaction>(),
  companies: $.collection<Company>(),
}));

@Injectable({
  providedIn: 'root',
})
export class OrmService {
  public groupsOfaddress = groups(db).addresses;
  public groupsOfUsers = groups(db).users;
  public allgroups = groups(db);
  public companyCollection = db.companies;
  public invoiceCollection = db.invoices;
  public issueCollection = db.issues;
  public machineCollection = db.machines;
  public serviceCollection = db.servicing;
  public storageCollection = db.storage;
  public transactionCollection = db.transactions;
  public userCollection = db.users;
  public addressthroughtUsr = (userId: Id<'users'>) => db.users(userId)['addresses'];

  // asd() {
  //   //this.userCollection('renodmId' as Id<"users">)['addresses'].add()
  //   // const q = this.usersOfAddressCollection.query(a=>{
  //   //   a.docId().
  //   // })
  // }
}

export type Schema = Typesaurus.Schema<typeof db>;
